import { FloatingContainer, Screen } from '../Container';
import CustomSpinner from '../CustomSpinner';

export const CardSpinner = () => (
  <Screen data-testid="screen">
    <FloatingContainer borderRadius={0} data-testid="floating-container" height="100%">
      <CustomSpinner isLoading />
    </FloatingContainer>
  </Screen>
);
